import axiosHandler from "interceptor/axiosInterceptor";

export const getDashboardStats = async () => {
  try {
    const response = await axiosHandler.get("/api/admin/dashboard/stats");
    return response;
  } catch (error) {
    throw error;
  }
};
